export const GreffierListStyle = {
  width: "100%",
};
